var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":_vm.countOfComment ? 'success' : 'default',"small":""},on:{"click":function($event){$event.stopPropagation();return _vm.showCommentAside(_vm.commentState)}}},[_vm._v(" Comments ("+_vm._s(_vm.countOfComment)+") ")])}
var staticRenderFns = []

export { render, staticRenderFns }